<template>
	<ion-page>
		<spot-header :title="pageTitle" :canGoHome="true" :showLogo="false" @pressedGoHome="tryExit"></spot-header>
		<ion-content :fullscreen="true">
			<ion-item v-if="!isActive || updatingLibraries">
				<ion-spinner name="lines" color="primary"></ion-spinner>
				<ion-label color="primary">{{ spinnerText}}</ion-label>
			</ion-item>
			<div id="actionArea" v-if="isActive">
				<div class="movement-code-area" v-if="currentRec"> <!--v-if="isActive"-->
					<span class="movement-code">{{ currentRec.code }}</span>
				</div>
				<div id="fieldsContainer" class="content-rows"> <!--v-if="isActive"-->
					<div v-if="currField.id == field.review" class="review-items">
						<span v-if="currField.required">*</span>
						<ion-item slot="start" lines="full" v-for="element in reviewFields.list" :key="element.id">
							<ion-label v-if="element.type=='text'">{{ element.text }}</ion-label>
							<ion-input v-if="element.type=='text' && element.value" type="text" readonly v-model="element.value"></ion-input>
							<ion-label v-if="element.type=='image'" position="fixed">{{ element.text }}</ion-label>
							<ion-thumbnail v-if="element.type=='image' && element.value"><img :src="element.value" /></ion-thumbnail>
						</ion-item>
						<ion-item slot="start" lines="full" class="hidden" v-for="element in reviewFields.extra" :key="element.id">
							<ion-label v-if="element.type=='text'">{{ element.text }}</ion-label>
							<ion-input v-if="element.type=='text' && element.value" type="text" readonly v-model="element.value"></ion-input>
							<ion-label v-if="element.type=='image'" position="fixed">{{ element.text }}</ion-label>
							<ion-thumbnail v-if="element.type=='image' && element.value"><img :src="element.value" /></ion-thumbnail>
						</ion-item>
					</div>
					<div v-if="currField.id == field.signature">
						<div class="items-label">
							<ion-label>{{ currField.text }}</ion-label>
							<span v-if="currField.required">*</span>
						</div>
						<div class="items-data">
							<signature v-if="!isClosed && !isDisposed" @saved="assignSignature" @removed="clearSignature"></signature>
							<ion-button fill="clear" :disabled="!currField.canAddItem" v-if="isVisibleButton(currField.canAddItem) && !isClosed && !isDisposed" @click="addItem(currField.refTable)">
								<ion-icon slot="icon-only" :icon="addCircleOutline" size="large"></ion-icon>
							</ion-button>
						</div>
					</div>
					<div v-if="currField.id == field.delegate">
						<spot-select-custom
							:ref="currField.name"
							:label="currField.text"
							:allignLabel="currField.allignLabel"
							:required="currField.required"
							:placeholder="getPlaceHolder()"
							:enabled="!isClosed &&	!isDisposed"
							:value="currField.value"
							:options="tablesData.employees"
							:optionField="currField.refField"
							:canAddItem="currField.canAddItem"
							:canRefreshList="currField.canRefresh"
							:canUnlock="currField.canUnlock"
							:custom-label="customEmployee"
							selectedLabel="Selezionato"
							deselectLabel="rimuovi"
							selectLabel="seleziona"
							@selected="detectSelection"
							@unselected="detectUnselection"
							@addItem="addEmployee">
						</spot-select-custom>
					</div>
					<div v-if="currField.id == field.moved">
						<div class="items-label">
							<ion-label>{{ currField.text }}</ion-label>
							<span v-if="currField.required">*</span>
						</div>
						<div class="items-data">
							<ion-checkbox slot="start" v-model="currField.value" :placeholder="getPlaceHolder()" :disabled="isClosed || isDisposed"></ion-checkbox>
							<ion-button fill="clear" :disabled="!currField.canAddItem" v-if="isVisibleButton(currField.canAddItem) && !isClosed && !isDisposed" @click="addItem()">
								<ion-icon slot="icon-only" :icon="addCircleOutline" size="large"></ion-icon>
							</ion-button>
						</div>
					</div>
				</div>
				<div id="actionsContainer"> <!--v-if="isActive"-->
					<spot-button
						v-if="isVisibleButton(currField.canGoBack)"
						fill="clear"
						size="large"
						color="primary"
						icon="chevronBackCircleOutline"
						:enabled="currField.canGoBack"
						:expand="null"
						:text=null
						@clicked="goBack()">
					</spot-button>
					<spot-button
						v-if="isVisibleButton(currField.canSkip)"
						fill="clear"
						size="large"
						color="primary"
						icon="playSkipForwardCircleOutline"
						:enabled="!isEmptyRequiredFields()"
						:expand="null"
						:text=null
						@clicked="goToSave()">
					</spot-button>
					<spot-button
						v-if="isVisibleButton(currField.canSave && !isClosed && !isDisposed && !isDisposable)"
						:fill="(showActionButtonsText) ? 'outline' : 'clear'"
						size="small"
						color="primary"
						icon="save"
						:enabled="!isEmptyRequiredFields()"
						:expand="null"
						:text="(showActionButtonsText) ? labelSave : null"
						@clicked="updateRecord()">
					</spot-button>
					<spot-button
						v-if="isVisibleButton(currField.canModify)"
						fill="outline"
						size="small"
						color="primary"
						icon="documentTextOutline"
						:enabled="!isDisableButton(currField.canModify)"
						:expand="null"
						:text="isClosed ? labelView : labelModify"
						@clicked="modifyRecord()">
					</spot-button>
					<spot-button
						v-if="isVisibleButton(currField.canReOpen && (isClosed ||	isDisposed))"
						fill="outline"
						size="small"
						color="primary"
						icon="folderOpenOutline"
						:enabled="true"
						:expand="null"
						:text="labelReOpen"
						@clicked="openClosedMovement()">
					</spot-button>
					<spot-button
						v-if="isVisibleButton(currField.canPickUp && !isClosed && !isDisposed && !isDisposable)"
						fill="outline"
						size="small"
						color="primary"
						icon="downloadOutline"
						:enabled="!isDisableButton(currField.canPickUp)"
						:expand="null"
						:text="labelPickup"
						@clicked="goAhead()">
					</spot-button>
					<spot-button
						v-if="isVisibleButton(currField.canReSend && !isClosed && !isDisposed && !isDisposable)"
						fill="outline"
						size="small"
						color="primary"
						icon="downloadOutline"
						:enabled="!isDisableButton(currField.canReSend)"
						:expand="null"
						:text="labelReSend"
						@clicked="executeReSend()">
					</spot-button>
					<spot-button
						v-if="isVisibleButton(currField.canDispose && !isClosed && !isDisposed &&	isDisposable && isDisposeAllowed)"
						fill="outline"
						size="small"
						color="primary"
						icon="trashBinOutline"
						:enabled="!isDisableButton(currField.canDispose)"
						:expand="null"
						:text="labelDispose"
						@clicked="executeDispose()">
					</spot-button>
					<spot-button
						v-if="isVisibleButton(currField.canPostpone && !isClosed && !isDisposed &&	isDisposable && isDisposeAllowed)"
						fill="outline"
						size="small"
						color="primary"
						icon="hourglassOutline"
						:enabled="!isDisableButton(currField.canPostpone)"
						:expand="null"
						:text="labelPostpone"
						@clicked="executePostpone()">
					</spot-button>
					<spot-button
						v-if="isVisibleButton(currField.canGoAhead)"
						fill="clear"
						size="large"
						color="primary"
						icon="chevronForwardCircleOutline"
						:enabled="!isDisableButton(currField.canGoAhead)"
						:expand="null"
						:text=null
						@clicked="goAhead()">
					</spot-button>
				</div>
			</div>
			<div id="debugArea" style="color:red;" v-if="settings.global.debug">
				<div>Test Area</div>
				Current Field: {{ currField }}<br>
				<div v-for="element in fields.list" :key="element.id">
					{{ element.name }} = {{ element.value }}
				</div>
			</div>
		</ion-content>
	</ion-page>
</template>

<style src="vue-multiselect/dist/vue-multiselect.css"></style> <!--<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>-->
<style scoped>
	ion-label {
		font-weight:bold;
	}
	.content-rows {
		display: flex;
		flex-direction: column;
		flex-wrap: wrap;
		/*justify-content: space-around;*/
		/*align-content: flex-start;*/
		/*padding: 1em;*/
		/*height: 10%;*/
		/*overflow: auto;*/
	}
	.hidden {
		--ion-background-color:lightgray;
	}
	.items-label {
		margin-top: .5em;
		margin-left: 1em;
	}
	.items-data {
		display: flex; /*inline-block;*/
		flex-direction: row;
		vertical-align: baseline;
		justify-content: space-between;
		text-align: left;
		margin-left: .5em;
		margin-right: .5em;
	}
	.movement-code-area {
		text-align: center;
		margin-top: .5em;
	}
	.movement-code {
		background: var(--ion-color-secondary);
		font-weight: bold;
	}
	ion-checkbox {
		margin-top: .5em;
		margin-left: .5em;
	}
	.review-items ion-item {
		--min-height: 0px;
	}
	.review-items ion-input {
		--padding-top: .5vh;
		--padding-bottom: .5vh;
	}
	.review-items :is(ion-label, ion-thumbnail) {
		margin-top: .5vh;
		margin-bottom: .5vh;
	}
</style>

<script>
	import { IonButton, IonCheckbox, IonContent, IonIcon, IonInput, IonItem, IonLabel, IonPage, IonSpinner, IonThumbnail } from "@ionic/vue";
	import { addCircleOutline, chevronBackCircleOutline, chevronForwardCircleOutline, documentTextOutline, downloadOutline, folderOpenOutline, hourglassOutline, playSkipForwardCircleOutline, save, trashBinOutline } from "ionicons/icons";
	import { defineComponent } from "vue";
	import Signature from "../components/Signature.vue";
	import SpotButton from "../components/SpotButton.vue";
	import SpotHeader from "../components/SpotHeader.vue";
	import SpotSelectCustom from "../components/SpotSelectCustom.vue";
	import { checkAdmin ,confirmYesNo, showMsgInfo, showMsgWarning } from "../plugins/common.js";
	import { settings } from "../plugins/settings.js";
	import { createEmployee, createProject, getPastDate, getProject, getProjectRow, jsonSearchProjectRows, tablesData, updateProject, updateProjectBulk, updateProjectFormDataBulk, updateProjectRow, updateProjectRowFormData } from '../plugins/customDatabase.js';
	import { backendUrl } from "../plugins/variables.js";

	export default defineComponent({
		name: "FinalizeReceipt",
		props: {
			pageTitle: { type: String, default: "Concludi Ricezione" },
			defaultSpinnerText: { type: String, default: "Caricamento..." },
			loadingEmployeesText: { type: String, default: "Caricamento Dipendenti..." },
			loadingProjectText: { type: String, default: "Caricamento Testata..." },
			loadingProjectRowText: { type: String, default: "Caricamento Dettaglio..." },
			exitConfirmTitle: { type: String, default: "Conferma Uscita" },
			exitConfirmMessage: { type: String, default: "Confermi l'uscita dalla maschera di inserimento, annullando eventuali dati inseriti (i dati andranno persi)?" },
			labelSave: { type: String, default: "Salva" },
			labelView: { type: String, default: "Visualizza" },
			labelModify: { type: String, default: "Modifica" },
			labelPickup: { type: String, default: "Ritira" },
			labelReOpen: { type: String, default: "Sblocca" },
			labelReSend: { type: String, default: "Rispedisci" },
			labelDispose: { type: String, default: "Smaltisci" },
			labelPostpone: { type: String, default: "Estendi" },
			messageTitle: { type: String, default: "Chiusura Ricezione" },
			successUpdateMessage: { type: String, default: "Ritiro avvenuto correttamente" },
			warningUpdateNoRowMessage: { type: String, default: "Non ci sono articoli da consegnare" },
			warningUpdateMessage: { type: String, default: "ATTENZIONE! Alcuni articoli non sono stati aggiornati" },
			warningClosingDenied: { type: String, default: "Non è consentito il Ritiro se il Destinatario non è stato assegnato" },
			warningDelegateDenied: { type: String, default: "Non è consentito selezionare come Delegato, il Destinatario della ricezione" },
			warningDeniedDisposeMessage: { type: String, default: "Il pacco è in modalità Smaltimento. Rivolgersi all'amministratore!" },
			reopenConfirmMessage: { type: String, default: "Confermi la riapertura del ritiro già chiuso?"},
			successMailMessage: { type: String, default: "Notificato ritiro via mail a: " },
			successMailMessages: { type: String, default: "Notificato ritiro via mail ai Destinatari " },
			messageTitleInsert: { type: String, default: "Creazione Sovracollo" },
			successSaveMessage: { type: String, default: "Sovracollo creato" },
			confirmDisposeMessage: { type: String, default: "Confermi lo smaltimento?" },
			successDisposeMessage: { type: String, default: "Elemento smaltito" },
			confirmPostponeMessage: { type: String, default: "Confermi l'estensione del periodo di smaltimento?" },
			successPostponeMessage: { type: String, default: "Esteso il tempo di smaltimento" },
			unselected: { type: String, default: "Nessuno" },
		},
		components: {
			IonPage,
			IonItem,
			IonButton,
			IonIcon,
			IonContent,
			IonSpinner,
			IonLabel,
			IonInput,
			IonCheckbox,
			IonThumbnail,
			Signature,
			SpotHeader,
			SpotButton,
			SpotSelectCustom,
		},
		data: () => ({
			isActive: null,
			isClosed: null,
			isDisposed: null,
			isDisposable: null,
			projectRowId: null,
			receiver: null,
			headerId: null,
			headerCode: null,
			multipack: null,
			isFromSearch: null,
			spinnerText: null,
			updatingLibraries: null,
			field: {
				review: 0,
				signature: 1,
				delegate: 2,
				moved: 3,
			},
			fields: {
				currentId: 0,
				list: [ //TODO: Nota che, in realtà canSkip, è poi uguale a NOT required (forse può essere rimosso), forse solo nel riepilogo è diverso, ma ci si può guardare
					{ id: 0, name: 'review', text: 'RIEPILOGO', allignLabel: false, placeholder: '', refTable: null, inputType: "readOnlyTexts", defaultValue: null, value: null, required: false, refField: null, canAddItem: false, canSkip: false, canGoBack: false, canGoAhead: false, canSave: false, canModify: false, canReOpen: false, canPickUp: true, canReSend: true, canDispose: true, canPostpone: true, canRefresh: false, canUnlock: false },
					{ id: 1, name: 'signature', text: 'Firma', allignLabel: false, placeholder: 'Firma Documento', refTable: null, inputType: "button", defaultValue: null, value: null, required: true, refField: null, canAddItem: false/*true*/, canSkip: true, canGoBack: false, canGoAhead: true, canSave: false, canModify: false, canReOpen: false, canPickUp: false, canReSend: false, canDispose: false, canPostpone: false, canRefresh: false, canUnlock: false },
					{ id: 2, name: 'delegate', text: 'Delegato', allignLabel: false, placeholder: 'Seleziona Delegato', refTable: 'employees', inputType: "combo", defaultValue: null, value: null, required: false, refField: 'id', canAddItem: false, canSkip: true, canGoBack: true, canGoAhead: true, canSave: false, canModify: false, canReOpen: false, canPickUp: false, canReSend: false, canDispose: false, canPostpone: false, canRefresh: false, canUnlock: false },
					{ id: 3, name: 'moved', text: 'Trasferito a Mi T35', allignLabel: false, placeholder: '', refTable: null, inputType: "check", defaultValue: null/*false*/, value: null/*false*/, required: false, refField: null, canAddItem: false, canSkip: false, canGoBack: true, canGoAhead: false, canSave: true, canModify: false, canReOpen: false, canPickUp: false, canReSend: false, canDispose: false, canPostpone: false, canRefresh: false, canUnlock: false },
				],
			},
			reviewField: {
				list: {
					carrier: 0,
					supplier: 1,
					employee: 2,
					second_employee: 3,
					item: 4,
					warehouse: 5,
					location: 6,
					tracking_number: 7,
					transport_document: 8,
					pictures: 9,
					received_unckecked: 10,
					note: 11,
				},
				extra: {
					signature: 0,
					delegate: 1,
					moved: 2,
				},
			},
			reviewFields: {
				list: [
					{ id: 0, name: 'carrier', text: 'Corriere:', value: null, type: 'text' },
					{ id: 1, name: 'supplier', text: 'Mittente:', value: null, type: 'text' },
					{ id: 2, name: 'employee', text: 'Destinatario:', value: null, type: 'text' },
					{ id: 3, name: 'second_employee', text: '2° Destinatario:', value: null, type: 'text' },
					{ id: 4, name: 'item', text: 'Formato:', value: null, type: 'text' },
					{ id: 5, name: 'warehouse', text: 'Magazzino:', value: null, type: 'text' },
					{ id: 6, name: 'location', text: 'Ubicazione:', value: null, type: 'text' },
					{ id: 7, name: 'tracking_number', text: 'Track ID:', value: null, type: 'text' },
					{ id: 8, name: 'transport_document', text: 'DDT:', value: null, type: 'text' },
					{ id: 9, name: 'pictures', text: 'Immagine:', value: null, type: 'image' },
					{ id: 10, name: 'received_unckecked', text: 'Accettazione con Riserva:', value: null, type: 'text' },
					{ id: 11, name: 'note', text: 'Note', value: null, type: 'text' },
				],
				extra: [
					{ id: 0, name: 'signature', text: 'Firma:', value: null, type: 'image' },
					{ id: 1, name: 'delegate', text: 'Delegato:', value: null, type: 'text' },
					{ id: 2, name: 'moved', text: 'Trasferito a Mi T35', value: null, type: 'text' },
				],
			},
			currentRec: {},
			showActionButtonsText : true,
			hasChangedSignature : false,
			chevronBackCircleOutline,
			chevronForwardCircleOutline,
			playSkipForwardCircleOutline,
			addCircleOutline,
			save,
			documentTextOutline,
			downloadOutline,
			trashBinOutline,
			hourglassOutline,
			folderOpenOutline,
			settings,
			checkAdmin,
			confirmYesNo,
			showMsgInfo,
			showMsgWarning,
			createEmployee,
			createProject,
			getProject,
			getProjectRow,
			getPastDate,
			jsonSearchProjectRows,
			tablesData,
			updateProject,
			updateProjectBulk,
			updateProjectFormDataBulk,
			updateProjectRow,
			updateProjectRowFormData,
			backendUrl,
		}),
		computed: {
			currField() {
				return this.fields.list[this.fields.currentId]
			},
			allOpenedProjectRows() {
				return {
					q: {
						'project_id_eq': this.headerId,
						'closed_eq': false,
						'disposed_eq': false,
					}
				}
			},
			isDisposeAllowed() {
				return (this.settings.global.unrestrictedDispose || checkAdmin(this.tablesData.currentUser))
			},
		},
		async ionViewWillEnter() {
			this.getUrlParamsAndQuery();
			this.setDefault();
			await this.getAllTablesData();
			await this.getCurrentProjectRow();
			await this.getCurrentProject();
			await this.checkDisposable();
			this.isActive=true;
		},
		ionViewWillLeave() {
			document.activeElement?.blur();
			this.isActive=false;
		},
		methods: {
			//Settings
			async getUrlParamsAndQuery() {
				this.projectRowId = this.$route.params.id || null;
				this.headerId = this.$route.query.header_id ? parseInt(this.$route.query.header_id) : null;
				this.multipack = (/true/i).test(this.$route.query.multipack);
				this.isFromSearch = (/true/i).test(this.$route.query.from_search);
			},
			tryExit() {
				if (!this.isClosed && !this.isDisposed && this.currField.id != this.field.review) {
					this.confirmYesNo(this.exitConfirmTitle, this.exitConfirmMessage)
					.then((data) => {
						if (data == true) {
							if (!this.multipack) this.$router.push("/home");
							else this.$router.push(`/revision/multiple/` + this.headerId + `?code=` + this.headerCode);
						}
					})
				}
				else {
					if (!this.multipack) this.$router.push("/home");
					else this.$router.push(`/revision/multiple/` + this.headerId + `?code=` + this.headerCode);
				}
			},
			getPlaceHolder() {
				return ((this.settings.global.showFieldsPlaceholder) ? (this.currField.required ? this.currField.placeholder : this.unselected ) : '')
			},
			isDisableButton(ability) {
				if (this.settings.global.fieldsCheckOnButtons && ability) {
					return (this.currField.required && !this.currField.value) ? true : false
				}
				else {
					return !ability
				}
			},
			isEmptyRequiredFields() {
				let ret = false;
				this.fields.list.forEach(element => {if (element.required && !element.value) ret=true});
				return ret;
			},
			isVisibleButton(ability) {
				return (this.settings.global.hideUnneededButtons) ? ability : true
			},
			customEmployee ({ name, surname, department, seat, seat_code }) {
				let infoDepartment = "";
				if (department)
					infoDepartment = " (" + department.name + ")"
				else if (seat)
					infoDepartment = " (" + seat + ")"
				else if (seat_code)
					infoDepartment = " (" + seat_code + ")"
				return name + " " + surname + infoDepartment
			},
			getEmployeeDepartment(srcObject) {
				let infoDepartment = "";
				if (srcObject.department)
					infoDepartment = " (" + srcObject.department.name + ")"
				else if (srcObject.seat)
					infoDepartment = " (" + srcObject.seat + ")"
				else if (srcObject.seat_code)
					infoDepartment = " (" + srcObject.seat_code + ")"
				return srcObject.name + " " + srcObject.surname + infoDepartment
			},
			//Database
			async getAllTablesData() {
				// Do Nothing
			},
			async checkDisposable() {
				const disposableDate = await getPastDate(this.settings.global.disposeWaitingDays);
				const createdAt = this.currentRec?.created_at;
				this.isDisposable = !!createdAt && createdAt < disposableDate;

				if (!this.isClosed	&& !this.isDisposed && this.isDisposable &&	!this.isDisposeAllowed) {
					this.showMsgWarning(this.messageTitle,this.warningDeniedDisposeMessage);
				}
			},
			async getCurrentProjectRow() {
				if (this.projectRowId) {
					this.spinnerText = this.loadingProjectRowText;
					await this.getProjectRow(this.projectRowId);
					if (this.tablesData.currentProjectRow) {
						this.currentRec = this.tablesData.currentProjectRow;
						//TODO: Da inserire la selzione automatica del delegate, prima era così ma ora non può andare: this.fields.list[this.field.delegate].value=this.currentRec.employee.id;
						this.reviewFields.list[this.reviewField.list.carrier].value=(this.currentRec.carrier) ? this.currentRec.carrier.name : null;
						this.reviewFields.list[this.reviewField.list.supplier].value=(this.currentRec.supplier) ? this.currentRec.supplier.name : null;
						//this.reviewFields.list[this.reviewField.list.employee].value=(this.currentRec.employee) ? this.currentRec.employee.name + ' ' + this.currentRec.employee.surname + (!this.currentRec.employee.department ? "" : " (" + this.currentRec.employee.department.name + ")") : null;
						this.reviewFields.list[this.reviewField.list.employee].value=(this.currentRec.employee) ? this.getEmployeeDepartment(this.currentRec.employee) : null;
						this.reviewFields.list[this.reviewField.list.second_employee].value=(this.currentRec.second_employee) ? this.getEmployeeDepartment(this.currentRec.second_employee) : null;
						this.reviewFields.list[this.reviewField.list.item].value=(this.currentRec.item) ? this.currentRec.item.code : null;
						this.reviewFields.list[this.reviewField.list.warehouse].value=(this.currentRec.warehouse) ? this.currentRec.warehouse.name : null;
						this.reviewFields.list[this.reviewField.list.location].value=(this.currentRec.location) ? this.currentRec.location.name : null;
						this.reviewFields.list[this.reviewField.list.tracking_number].value=(this.currentRec.tracking_number) ? this.currentRec.tracking_number : null;
						this.reviewFields.list[this.reviewField.list.transport_document].value=(this.currentRec.transport_document) ? this.currentRec.transport_document : null;
						this.reviewFields.list[this.reviewField.list.pictures].value=(this.currentRec.picture_urls) ? this.backendUrl + this.currentRec.picture_urls : null;
						this.reviewFields.list[this.reviewField.list.received_unckecked].value=(this.currentRec.received_unckecked) ? 'Si' : 'No';
						this.reviewFields.list[this.reviewField.list.note].value=(this.currentRec.notes && this.currentRec.notes.body) ? this.currentRec.notes.body : null;
						this.isClosed=(this.currentRec.closed) ? true : false;
						this.isDisposed=(this.currentRec.disposed) ? true : false;
						this.reviewFields.extra[this.reviewField.extra.signature].value=(this.currentRec.signature_url) ? this.backendUrl + this.currentRec.signature_url : null;
						//this.reviewFields.extra[this.reviewField.extra.delegate].value=(this.currentRec.delegate) ? this.currentRec.delegate.name + ' ' + this.currentRec.delegate.surname + (!this.currentRec.delegate.department ? "" : " (" + this.currentRec.delgate.department.name + ")") : null;
						this.reviewFields.extra[this.reviewField.extra.delegate].value=(this.currentRec.delegate) ? this.getEmployeeDepartment(this.currentRec.delegate) : null;
						this.reviewFields.extra[this.reviewField.extra.moved].value=(this.currentRec.moved) ? 'Si' : 'No';
						this.fields.list[this.field.moved].value=(this.currentRec.moved) ? this.currentRec.moved : false;
						//this.headerId=this.currentRec.project.id;
						this.headerCode=this.currentRec.project.code;
					}
				}
			},
			async getCurrentProject() {
				if (this.headerId) {
					this.spinnerText = this.loadingProjectText;
					await this.getProject(this.headerId);
					if (this.tablesData.currentProject) {
						this.isClosed=(this.tablesData.currentProject.closed) ? true : false;
						this.headerCode = this.tablesData.currentProject.code;
						this.goAhead();
					}
				}
			},
			async searchOpenedProjectRows() {
				if (this.headerId) {
					await this.searchRecords(this.allOpenedProjectRows);
				}
			},
			async searchRecords(currSearch) {
				this.tablesData.projectRows = [];
				await this.jsonSearchProjectRows(currSearch);
			},
			prepareUpdateProjectRow() {
				let myRecord = {
					project_row: {
						signature: (this.fields.list[this.field.signature].value) ? this.fields.list[this.field.signature].value.id : null,
						delegate_id: (this.fields.list[this.field.delegate].value) ? this.fields.list[this.field.delegate].value.id : null,
						moved: (this.fields.list[this.field.moved].value) ? this.fields.list[this.field.moved].value : false,
						closed: true,
						disposed: false,
					}
				};
				return myRecord;
			},
			prepareBulkUpdateProjectRowsInProject() {
				let myRecord = {
					fields: {
						signature: (this.fields.list[this.field.signature].value) ? this.fields.list[this.field.signature].value.id : null,
						delegate_id: (this.fields.list[this.field.delegate].value) ? this.fields.list[this.field.delegate].value.id : null,
						moved: (this.fields.list[this.field.moved].value) ? this.fields.list[this.field.moved].value : false,
						closed: true,
						disposed: false,
					}
				};
				return myRecord;
			},
			prepareUpdateProjectRow_FormData() {
				let myRecord = new FormData();
				if (this.hasChangedSignature) myRecord.append('project_rows[signature]', this.fields.list[this.field.signature].value);
				if (this.fields.list[this.field.delegate].value) myRecord.append('project_rows[delegate_id]', this.fields.list[this.field.delegate].value.id);
				myRecord.append('project_rows[closed]', true);
				myRecord.append('project_rows[disposed]', false);
				myRecord.append('project_rows[moved]', (this.fields.list[this.field.moved].value) ? this.fields.list[this.field.moved].value : false);
				return myRecord;
			},
			prepareBulkUpdateProjectRowsInProject_FormData() {
				let myRecord = new FormData();
				if (this.hasChangedSignature) myRecord.append('project_rows[signature]', this.fields.list[this.field.signature].value);
				if (this.fields.list[this.field.delegate].value) myRecord.append('project_rows[delegate_id]', this.fields.list[this.field.delegate].value.id);
				myRecord.append('project_rows[closed]', true);
				myRecord.append('project_rows[disposed]', false);
				myRecord.append('project_rows[moved]', (this.fields.list[this.field.moved].value) ? this.fields.list[this.field.moved].value : false);
				return myRecord;
			},
			prepareUpdateProjectRow_EmptyFinalize() {
				let myRecord = {
					project_row: {
						signature: null,
						delegate_id: null,
						moved: false,
						closed: false,
						disposed: false,
					}
				};
				return myRecord;
			},
			prepareDisposeProjectRow() {
				let myRecord = {
					project_row: {
						disposed: true,
					}
				};
				return myRecord;
			},
			preparePostponeProjectRow(newCreatedAtDate = null) {
				let myRecord = {
					project_row: {
						created_at: newCreatedAtDate,
					}
				};
				return myRecord;
			},
			async updateRecord(executeRedirect = true) {
				if (!this.headerId) {
					if (!this.fields.list[this.field.delegate].value || !this.currentRec || !this.currentRec.employee || this.fields.list[this.field.delegate].value.id != this.currentRec.employee.id) {
						if (!this.fields.list[this.field.signature].value) await this.updateRecordJson(executeRedirect);
						else await this.updateRecordFormData(executeRedirect);
					}
					else {
						this.showMsgWarning(this.messageTitle, this.warningDelegateDenied)
						this.currField.value = this.currField.defaultValue;
					}
				}
				else {
					if (!this.fields.list[this.field.signature].value) await this.updateBulkRecordsJson(executeRedirect); //this.updateAllRecordsJson(executeRedirect);
					else await this.updateAllRecordsFormData(executeRedirect); //this.updateBulkRecordsFormData(executeRedirect);
				}
			},
			async disposeRecord(executeRedirect = true) {
				this.tablesData.currentProjectRow = null;
				await this.updateProjectRow(this.projectRowId, this.prepareDisposeProjectRow(), false)
				if (this.tablesData.currentProjectRow) {
					if (this.tablesData.currentProjectRow.employee) {
						this.receiver = "<br><br>" + this.successMailMessage + "&nbsp" + this.tablesData.currentProjectRow.employee.name + "&nbsp" + this.tablesData.currentProjectRow.employee.surname;
					} else {
						this.receiver = ""/*null*/;
					}
					await this.showMsgInfo(this.messageTitle, this.successDisposeMessage + this.receiver);
					if (executeRedirect) {
						if (!this.isFromSearch) this.$router.push("/home");
						else this.$router.push(`/search?disposable=true`);
					}
				}
			},
			async postponeRecord(executeRedirect = true) {
				this.tablesData.currentProjectRow = null;
				const newCreatedAtDate = await getPastDate(this.settings.global.disposeWaitingDays - 1);
				await this.updateProjectRow(this.projectRowId, this.preparePostponeProjectRow(newCreatedAtDate), false)
				if (this.tablesData.currentProjectRow) {
					await this.showMsgInfo(this.messageTitle, this.successPostponeMessage);
					if (executeRedirect) {
						if (!this.isFromSearch) this.$router.push("/home");
						else this.$router.push(`/search?disposable=true`);
					}
				}
			},
			async updateRecordJson(executeRedirect = true) {
				this.tablesData.currentProjectRow = null;
				await this.updateProjectRow(this.projectRowId, this.prepareUpdateProjectRow(), false)
				if (this.tablesData.currentProjectRow) {
					if (this.tablesData.currentProjectRow.employee) {
						this.receiver = "<br><br>" + this.successMailMessage + "&nbsp" + this.tablesData.currentProjectRow.employee.name + "&nbsp" + this.tablesData.currentProjectRow.employee.surname;
					} else {
						this.receiver = ""/*null*/;
					}
					this.showMsgInfo(this.messageTitle, this.successUpdateMessage + this.receiver);
					if (executeRedirect) {
						if (!this.multipack) this.$router.push("/home");
						else this.$router.push(`/revision/multiple/` + this.headerId + `?code=` + this.headerCode);
					}
				}
			},
			async updateAllRecordsJson(executeRedirect = true) {
				await this.searchOpenedProjectRows();
				if (this.tablesData.projectRows.length>0) {
					let state = true;
					for (const element of this.tablesData.projectRows) {
						if (await this.updateProjectRow(element.id, this.prepareUpdateProjectRow(), false) == false) {
							state = false;
						}
					}
					if (state == true) {
						this.showMsgInfo(this.messageTitle,this.successUpdateMessage + "<br><br>" + this.successMailMessages);
					}
				}
				else {
					this.showMsgWarning(this.messageTitle,this.warningUpdateNoRowMessage);
				}
				if (executeRedirect) {
					this.$router.push(`/revision/multiple/` + this.headerId + `?code=` + this.headerCode);
				}
			},
			async updateBulkRecordsJson(executeRedirect = true) {
				await this.searchOpenedProjectRows();
				if (this.tablesData.projectRows.length>0) {
					if (await this.updateProjectBulk(this.headerId, this.prepareBulkUpdateProjectRowsInProject(), false) == this.tablesData.projectRows.length) {
						this.showMsgInfo(this.messageTitle,this.successUpdateMessage + "<br><br>" + this.successMailMessages);
					} else {
						this.showMsgWarning(this.messageTitle,this.warningUpdateMessage);
					}
				}
				else {
					this.showMsgWarning(this.messageTitle,this.warningUpdateNoRowMessage);
				}
				if (executeRedirect) {
					this.$router.push(`/revision/multiple/` + this.headerId + `?code=` + this.headerCode);
				}
			},
			async updateRecordFormData(executeRedirect = true) {
				this.tablesData.currentProjectRow = null;
				await this.updateProjectRowFormData(this.projectRowId, this.prepareUpdateProjectRow_FormData(), false)
				if (this.tablesData.currentProjectRow) {
					if (this.tablesData.currentProjectRow.employee) {
						this.receiver = "<br><br>" + this.successMailMessage + "&nbsp" + this.tablesData.currentProjectRow.employee.name + "&nbsp" + this.tablesData.currentProjectRow.employee.surname;
					} else {
						this.receiver = ""/*null*/;
					}
					this.showMsgInfo(this.messageTitle, this.successUpdateMessage + this.receiver);
					if (executeRedirect) {
						if (!this.multipack) this.$router.push("/home");
						else this.$router.push(`/revision/multiple/` + this.headerId + `?code=` + this.headerCode);
					}
				}
			},
			async updateAllRecordsFormData(executeRedirect = true) {
				await this.searchOpenedProjectRows();
				if (this.tablesData.projectRows.length>0) {
					let state = true;
					for (const element of this.tablesData.projectRows) {
						if (await this.updateProjectRowFormData(element.id, this.prepareUpdateProjectRow_FormData(), false) == false) {
							state = false;
						}
					}
					if (state==true) {
						this.showMsgInfo(this.messageTitle,this.successUpdateMessage + "<br><br>" + this.successMailMessages);
					}
				}
				else {
					this.showMsgWarning(this.messageTitle,this.warningUpdateNoRowMessage);
				}
				if (executeRedirect) {
					this.$router.push(`/revision/multiple/` + this.headerId + `?code=` + this.headerCode);
				}
			},
			async updateBulkRecordsFormData(executeRedirect = true) {
				await this.searchOpenedProjectRows();
				if (this.tablesData.projectRows.length>0) {
					if (await this.updateProjectFormDataBulk(this.headerId, this.prepareBulkUpdateProjectRowsInProject_FormData(), false) == this.tablesData.projectRows.length) {
						this.showMsgInfo(this.messageTitle,this.successUpdateMessage + "<br><br>" + this.successMailMessages);
					} else {
						this.showMsgWarning(this.messageTitle,this.warningUpdateMessage);
					}
				}
				else {
					this.showMsgWarning(this.messageTitle,this.warningUpdateNoRowMessage);
				}
				if (executeRedirect) {
					this.$router.push(`/revision/multiple/` + this.headerId + `?code=` + this.headerCode);
				}
			},
			async openClosedMovement() {
				let fieldValue = false;
				await this.confirmYesNo(this.messageTitle, this.reopenConfirmMessage)
				.then((data) => { if (data) { fieldValue = data } })
				if (fieldValue == true) {
					if (await this.updateProjectRow(this.projectRowId, this.prepareUpdateProjectRow_EmptyFinalize(), false) == true) {
						await this.getCurrentProjectRow();
					}
				}
			},
			//Actions
			setDefault() {
				this.spinnerText = this.defaultSpinnerText;
				this.fields.currentId = 0;
				this.fields.list.forEach(element => element.value = element.defaultValue);
				// this.multipack = false;
				// this.headerId = null;
				this.headerCode = null;
				this.isClosed = false;
				this.isDisposed = false;
				this.isDisposable = false;
				this.hasChangedSignature = false;
				this.updatingLibraries = false;
				this.enableChangesOnProjectRows();
			},
			enableChangesOnProjectRows() {
				this.fields.list[this.field.review].canModify = !this.settings.finalizeReceipt.disableChangeOnProjectRow;
				this.fields.list[this.field.review].canReOpen = !this.settings.finalizeReceipt.disableChangeOnProjectRow;
			},
			modifyRecord() {
				this.$router.push(`/insert/receipt/${this.$route.params.id}`+ (this.multipack ? `?multipack=true` : ``));
			},
			detectReturn(keyCode) {
				if (keyCode == 13) setTimeout(() => this.goAhead(), 0);
			},
			detectSelection(value) {
				this.currField.value = value;
				if (!value || !this.currentRec || !this.currentRec.employee || value.id != this.currentRec.employee.id) {
					if (this.settings.global.nextFieldOnComboSelect) setTimeout(() => this.goAhead(), 0);
				}
				else {
					showMsgWarning(this.messageTitle, this.warningDelegateDenied)
				}
			},
			detectUnselection() {
				this.currField.value = this.currField.defaultValue;
			},
			goBack() {
				if (!this.headerId) {
					if (this.fields.currentId >= this.field.review ) this.fields.currentId-=1;
				}
				else {
					if (this.fields.currentId > this.field.delegate ) this.fields.currentId-=1;
				}
			},
			goAhead() {
				if (this.fields.currentId <= (this.fields.list.length-1)) {
					if (this.fields.currentId == this.field.review && !this.headerId && !this.reviewFields.list[this.reviewField.list.employee].value) {
						this.showMsgWarning(this.messageTitle, this.warningClosingDenied);
					}
					else {
						this.fields.currentId+=1
					}
				}
				else {
					this.executeLastFieldAction()
				}
			},
			goToSave() {
				if (this.fields.currentId >= 0 && this.fields.currentId <= (this.fields.list.length-1) ) this.fields.currentId=this.fields.list.length-1
			},
			assignSignature(file) {
				this.hasChangedSignature = true;
				this.currField.value = file;
			},
			clearSignature() {
				this.currField.value = null;
			},
			executeLastFieldAction() {
				//TODO: Da Implementare (vedi quello della Insert, ma forse non serve perchè potrei abilitare solo il pulsante di salvataggio)
			},
			async addEmployee() {
				let fieldValue = null;
				await this.insertValue(this.newValueTitle, this.currField.text)
				.then((data) => { if (data) { fieldValue = data } })
				if (fieldValue) {
					let myRecord = {
						employees: {
							name: fieldValue,
						}
					}
					this.updatingLibraries = true;
					this.spinnerText = this.loadingEmployeesText;
					await this.createEmployee(myRecord);
					this.updatingLibraries = false;
					this.currField.value = this.tablesData.currentEmployee;
				}
			},
			addItem(tableName) {
				if (tableName) {
					//TODO: Possibilmente implementa la funzionalità generica AddItem
				}
			},
			async executeReSend() {
				if (this.projectRowId) {
					await this.updateRecord(false);
					await this.saveRecord_Insert();
					this.$router.push(`/insert/shipment?header_id=` + this.tablesData.currentProject.id + `&multiple=` + false + `&parent_id=` + this.tablesData.currentProjectRow.id);
				}
			},
			async executeDispose() {
				if (this.projectRowId) {
					let fieldValue = false;
					await this.confirmYesNo(this.messageTitle, this.confirmDisposeMessage)
					.then((data) => { if (data) { fieldValue = data } })
					if (fieldValue == true) {
						await this.disposeRecord(true);
						// this.$router.push(`/search?disposable=true`);
					}
				}
			},
			async executePostpone() {
				if (this.projectRowId) {
					let fieldValue = false;
					await this.confirmYesNo(this.messageTitle, this.confirmPostponeMessage)
					.then((data) => { if (data) { fieldValue = data } })
					if (fieldValue == true) {
						await this.postponeRecord(true);
						// this.$router.push(`/search?disposable=true`);
					}
				}
			},
			prepareNewProject() {
				let myRecord = {
					project: {
						name: "PACC", // this.currentProjectRow.project.name
						receiving: false,
						shipping: true,
						warehouse_id: this.tablesData.currentWarehouse.id,
						plant_id: this.tablesData.currentPlant.id,
					}
				};
				return myRecord;
			},
			prepareUpdateProject() {
				let myRecord = {
					project: {
						employee_id: (this.currentRec.employee) ? this.currentRec.employee.id : null,
						carrier_id: (this.currentRec.carrier) ? this.currentRec.carrier.id : null,
						item_id: (this.currentRec.item) ? this.currentRec.item.id : null,
					}
				};
				return myRecord;
			},
			async saveRecord_Insert() {
				this.tablesData.currentProject = null;
				await this.createProject(this.prepareNewProject(), false);
				if (this.tablesData.currentProject) {
					await this.updateProject(this.tablesData.currentProject.id, this.prepareUpdateProject(), false);
					this.showMsgInfo(this.messageTitleInsert, this.successSaveMessage);
				}
			},
		},
	});
</script>